import { MarqCommonEnumsChannelTypeEnum, MarqCommonEnumsDomainTypeEnum } from '~/swagger/data-contracts';
import { DomainTypeEnum } from '~/types/common/DomainTypeEnum';

/**
 * @note-jamie: [PROD-11001] 전사적으로 쓰이는 워딩이 업데이트됨에 따라,
 * FE코드에서도 가능한한 ecommerce -> marketplace 로 변경하지만,
 * BE와 통신하는 부분과 amplitude는 기존 이름을 일단은 유지하기 위해 이 함수를 사용.
 */

/**
 * View 전용 enum -> API param
 * 'marketplace' => ['ecommerce']
 */
export const parseDomainTypeToApiChannelTypeParam = (
  domainType: DomainTypeEnum | DomainTypeEnum[]
): MarqCommonEnumsChannelTypeEnum[] => {
  switch (domainType) {
    case DomainTypeEnum.Marketplace:
      return [MarqCommonEnumsChannelTypeEnum.Ecommerce];
    case DomainTypeEnum.SocialMedia:
      return [MarqCommonEnumsChannelTypeEnum.SocialMedia];
    default:
      return [MarqCommonEnumsChannelTypeEnum.Ecommerce];
  }
};
export const parseDomainTypeToApiDomainTypeParam = (
  domainType: DomainTypeEnum | DomainTypeEnum[]
): MarqCommonEnumsDomainTypeEnum[] => {
  switch (domainType) {
    case DomainTypeEnum.Marketplace:
      return [MarqCommonEnumsDomainTypeEnum.Ecommerce];
    case DomainTypeEnum.SocialMedia:
      return [MarqCommonEnumsDomainTypeEnum.SocialMedia];
    default:
      return [MarqCommonEnumsDomainTypeEnum.Ecommerce];
  }
};

/**
 * Amplitude label
 * 'marketplace' => 'marketplace'
 * 'social_media' => 'social media'
 */
export const parseChannelToAmplitudeLabel = (channel: 'marketplace' | 'social_media') => {
  if (channel === 'marketplace') return 'marketplace';
  return 'social media';
};
